<template>
  <!-- viewBox="0 0 30 30" -->
  <path
    d="M8 27H22C23.1046 27 24 26.1046 24 25V8.82843C24 8.29799 23.7893 7.78929 23.4142 7.41421L19.5858 3.58579C19.2107 3.21071 18.702 3 18.1716 3H8C6.89543 3 6 3.89543 6 5V25C6 26.1046 6.89543 27 8 27Z"
    fill="#3769D6"
  />
  <path
    d="M16.9999 21.0009C16.9996 21.553 16.552 22.0009 15.9999 22.0009H13.9999C13.4476 22.0009 12.9999 21.5522 12.9999 20.9999V17.0009H16.9999V21.0009ZM14.6093 12.4882C14.8094 12.2383 15.1894 12.2384 15.3895 12.4882L18.3495 16.1884C18.6112 16.5158 18.3781 16.9999 17.9589 16.9999H12.0399C11.6208 16.9999 11.3878 16.5158 11.6493 16.1884L14.6093 12.4882Z"
    fill="white"
  />
  <path
    opacity="0.5"
    d="M17 9.5L17 6.20711C17 5.76165 17.5386 5.53857 17.8536 5.85355L21.1464 9.14645C21.4614 9.46143 21.2383 10 20.7929 10L17.5 10C17.2239 10 17 9.77614 17 9.5Z"
    fill="white"
  />
</template>
